// extracted by mini-css-extract-plugin
export default {"editContainer":"EditProductPage_editContainer__sHH+6"};